import { t } from 'i18next'
import * as S from './styles'
import { Controller, useForm } from 'react-hook-form'
import { NewInput } from 'components/NewInput'
import { IMaskInput } from 'react-imask'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { FooterWithButtons } from 'pages/Checkin/components/FooterWithButtons'
import { useEffect, useState } from 'react'
import { useSessionStorage } from 'context/sessionStorage'
import { useArrivalAndDepartureSchema } from 'pages/Checkin/schemas/ArrivalAndDeparture'
import { useNavigate } from 'react-router-dom'

const warningIcon = require('../../../../assets/svg/checkin/Warning.svg').default

export const ArrivalAndDepartureTime = () => {

    const { saveToSessionStorage, getFromSessionStorage } = useSessionStorage()
    const [arrivalDate, setArrivalDate] = useState<string>('')
    const [departureDate, setDepartureDate] = useState<string>('')

    const schema = useArrivalAndDepartureSchema();

    type FormData = z.infer<typeof schema>;

    const { handleSubmit, formState: { errors }, setValue, control, trigger } = useForm<FormData>({
        resolver: zodResolver(schema),
    });


    function formatDate(data: string): string {
        const [ano, mes, dia] = data.split('-');
        const dataFormatada = new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia));
        return dataFormatada.toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' });
    }

    const pathnameActual: string = window.location.pathname.endsWith('/') ? window.location.pathname.slice(0, -1) : window.location.pathname.slice(0, window.location.pathname.lastIndexOf('/'));

    const formatHours = (hour: string) => {

        return `${hour.slice(0, 2)}:${hour.slice(2, 4)}`

    }


    const navigate = useNavigate()

    useEffect(() => {

        const dataReserves = getFromSessionStorage('checkin-details')
        if (dataReserves) {
            console.log(dataReserves, 'dataReserves')
            setArrivalDate(formatDate(dataReserves.arrival_date))
            setDepartureDate(formatDate(dataReserves.departure_date))
        }
        const hourReserves = getFromSessionStorage('arrival-and-departure-time')
        if (hourReserves) {
            setValue('arrivalHour', hourReserves.arrival_time)
            setValue('departureHour', hourReserves.checkout_time)
        }
        console.log(hourReserves, 'dataReserves')
    }, [])

    const onSubmit = (data: FormData) => {
        saveToSessionStorage('arrival-and-departure-time', { arrival_time: formatHours(data.arrivalHour), checkout_time: formatHours(data.departureHour) })
        navigate(`${pathnameActual}/additional-info`)
    }

    const handleBackPage = () => {
        navigate(`${pathnameActual}/accompanying`)
    }

    return (
        <S.ContainerArrivalAndDepartureTime>
            <h3>{t('checkin.arrivalAndDepartureTime.title')}</h3>
            <h5>{t('checkin.arrivalAndDepartureTime.subtitle')}</h5>
            <S.FormArrivalAndDeparture>
                <S.HoursContainerInput>
                    <S.HoursContainerLabel>
                        <strong>{t('checkin.arrivalAndDepartureTime.arrival')}</strong>
                        <p>{arrivalDate}</p>
                    </S.HoursContainerLabel>
                    <Controller
                        name="arrivalHour"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                            <NewInput width={'100%'} mask={''} id="arrivalHour" name="arrivalHour" htmlFor="arrivalHour" placeholder={"00:00"} title={t('checkin.arrivalAndDepartureTime.forms.label.checkinTime')} type="text" errorText={errors.arrivalHour?.message}>
                                <IMaskInput
                                    mask={'00:00'}
                                    radix="."
                                    unmask={true} // true|false|'typed'
                                    value={value}
                                    onAccept={(value, mask) => {
                                        onChange(value)
                                    }}
                                    placeholder={"00:00"}
                                    onBlur={() => trigger('arrivalHour')}
                                />
                            </NewInput>
                        )}
                    />
                </S.HoursContainerInput>
                <S.HoursContainerInput>
                    <S.HoursContainerLabel>
                        <strong>{t('checkin.arrivalAndDepartureTime.departure')}</strong>
                        <p>{departureDate}</p>
                    </S.HoursContainerLabel>
                    <Controller
                        name="departureHour"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                            <NewInput width={'100%'} mask={''} id="departureHour" name="departureHour" htmlFor="departureHour" placeholder={"00:00"} title={t('checkin.arrivalAndDepartureTime.forms.label.checkoutTime')} type="text" errorText={errors.departureHour?.message}>
                                <IMaskInput
                                    mask={'00:00'}
                                    radix="."
                                    unmask={true} // true|false|'typed'
                                    value={value}
                                    onAccept={(value, mask) => {
                                        onChange(value)
                                    }}
                                    placeholder={"00:00"}
                                    onBlur={() => trigger('departureHour')}
                                />
                            </NewInput>
                        )}
                    />
                </S.HoursContainerInput>
            </S.FormArrivalAndDeparture>
            <S.Warningmessage>
                <img src={warningIcon} alt="" />
                <p>{t('checkin.arrivalAndDepartureTime.warningText')}</p>
            </S.Warningmessage>
            <FooterWithButtons handleBackStep={handleBackPage} handleNextStep={handleSubmit(onSubmit)} />
        </S.ContainerArrivalAndDepartureTime>
    )
}